import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: left;
`;

export const DropdownButton = styled.button`
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  background-color: #171a3b;
  border: none;
  border-bottom: 1px solid #494c6a;
  color: white;
  border-radius: 4px;
  cursor: pointer;
`;

export const DropdownLabel = styled.span`
  text-transform: uppercase;
`;

export const DropdownIcon = styled.svg`
  width: 20px;
  height: 20px;
  margin-left: 8px;
`;

export const DropdownMenuContainer = styled.div`
  position: absolute;
  right: 0;
  z-index: 10;
  width: 100%;
  margin-top: 8px;
  background-color: #171a3b;
  border: 1px solid #494c6a;
  border-radius: 4px;
`;

export const DropdownMenu = styled.div`
  max-height: 192px;
  overflow-y: auto;
  padding-bottom: 8px;
`;

export const DropdownItem = styled.button`
  display: block;
  width: 100%;
  padding: 8px 16px;
  font-size: 14px;
  text-align: left;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #2a2d48;
  }
`;
